export default __webpack_public_path__ + "static/media/qukes-miniroos-thumbnail.1338da1b.jpg";